import React from "react";

export default function NoResultsMsgBlock(props) {
    return (
		<>
    	  	<div className="container" data-testid="no-result-block">
    		 <div className="d-flex flex-column justify-content-md-center flex-md-row mt-5">
	    		<div className=" pb-3  text-center ">
	    		  	{/* <props.noresultsImg width="200px" height="200px" /> */}
					  <img src={props.noresultsImg} className="noResultsImg-h-w" />
	    		</div>
	        	<div className="align-self-center text-center text-sm-left  ml-md-9">
	        		<p className="pb-md-3 pb-5 text-md-left text-center justify-content-sm-center">
	        		 	{props.noResultsMessage} 
				    </p>
	        		<a className="shadow-1 btn btn-priority w-auto w-md-75" href={props.noResultsUrl} >{props.noResultBtnText}</a>
	        	</div>
	        </div>
	        </div>
         </> 
    );

}